// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".interactive-video .xgplayer-skin-custom .xgplayer-poster{position:absolute;top:0;left:0;z-index:5;display:none;align-items:center;justify-content:center;width:100%;height:100%;overflow:hidden;background-position:50%;background-size:cover}.interactive-video .xgplayer-skin-custom .xgplayer-poster img{width:100%}.interactive-video .xgplayer-skin-custom.xgplayer-nostart .xgplayer-poster{display:flex}", ""]);
// Exports
module.exports = exports;
